<template>
  <div>
    <v-row>
      <v-col cols class="text-start">
        <span class="textLight--text font-weight-medium text-h5 text-start">
          {{ $t("quiz.completedAssessments") }}
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <AssessmentHistoryList
          :assessmentReports="assessmentReports"
          :loading="loading"
        />
      </v-col>
    </v-row>

    <v-row v-if="assessmentReports.length" class="mt-3">
      <v-col cols="12" style="max-width: 1150px">
        <Pagination :length="totalPages" @onPageSelect="onPagination" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AssessmentHistoryList from "@/app/quiz-module/components/AssessmentHistoryList";
import Pagination from "@/app/core-module/components/Pagination";

export default {
  name: "AssessmentHistory",
  components: {
    AssessmentHistoryList,
    Pagination,
  },
  data() {
    return {
      loading: true,
      assessmentReports: [],
      totalCount: 0,

      pageInput: this.defaultPageInput(),
      filterInput: null,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.pageInput.limit);
    },
  },
  apollo: {
    getQuizAttempts() {
      return {
        query: require("../../quiz-module/api/query/getQuizAttempts.gql"),
        variables: this.getVariables(),
        result({ data, loading }) {
          if (data?.getQuizAttempts?.quizAttempts) {
            this.assessmentReports = data.getQuizAttempts.quizAttempts ?? [];
            this.totalCount = data.getQuizAttempts.totalCount ?? 0;
          }

          this.loading = loading;
        },
      };
    },
  },
  methods: {
    getVariables() {
      return { pageInput: this.pageInput, filterInput: this.filterInput };
    },
    reFetch() {
      this.$apollo.queries.getQuizAttempts.refetch(this.getVariables());
    },
    onPagination(val) {
      if (val > 0) {
        this.pageInput.skip = this.pageInput.limit * (val - 1);
        this.reFetch();
      }
    },
  },
};
</script>
